export function recuperarDadosVinculo(vinculo) {
  const codigo = vinculo.substr(0, 8);
  const sequencia = vinculo.substr(8, 2);
  return { codigo, sequencia };
}
